import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

export const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      
      // Also check any scrollable container
      let containerScroll = 0;
      const mainEl = document.querySelector('main') || document.querySelector('#root');
      if (mainEl) {
        containerScroll = mainEl.scrollTop;
      }

      const activeScroll = Math.max(scrollY, containerScroll);
      setIsVisible(activeScroll > 280);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    document.addEventListener('scroll', handleScroll, { passive: true, capture: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('scroll', handleScroll, { capture: true });
    };
  }, []);

  const scrollToTop = () => {
    // 1. Scroll window
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    // 2. Scroll documentElement / body
    if (document.documentElement) {
      document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (document.body) {
      document.body.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // 3. Scroll any inner containers
    const scrollContainers = document.querySelectorAll<HTMLElement>(
      '#root, main, .sz-page-container, .sz-dashboard-root, [data-scroll-container]'
    );
    scrollContainers.forEach(container => {
      if (container && container.scrollTop > 0) {
        container.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Back to top"
      title="Back to top"
      className="fixed bottom-24 md:bottom-8 right-5 z-40 p-3 rounded-full bg-neutral-900/90 hover:bg-neutral-800 text-white border border-white/15 hover:border-white/30 shadow-2xl backdrop-blur-md transition-all duration-300 hover:scale-105 active:scale-95 group flex items-center gap-2 text-xs font-semibold no-print"
    >
      <ArrowUp size={16} className="text-neutral-300 group-hover:text-white transition-transform group-hover:-translate-y-0.5" />
      <span className="hidden sm:inline text-[11px] font-mono tracking-wider uppercase pr-1 text-neutral-300 group-hover:text-white">
        Back to top
      </span>
    </button>
  );
};
